/* ── INVASIVE THOT CUSTOM ─────────────────────────────────────
   Erratic typewriter for the in-header marquee ("type" style).
   Scripted cycle, The Shining style:
     rep 1 — types straight through, ends "."
     rep 2 — types, deletes "slut" once, retypes it, ends "!!!"
     rep 3 — types until it hits the right margin, gets cut off
             mid-word, holds, page rips out, cycle restarts
   Timing is jittery-human: bursts, hesitations, dead stalls.
   Markup lives in sections/header.liquid; styles in
   assets/invasive-thot.css (.it-typewriter).
   ───────────────────────────────────────────────────────────── */

(() => {
  const rand = (a, b) => a + Math.random() * (b - a);

  const delay = () => {
    const r = Math.random();
    if (r < 0.06) return rand(450, 900); /* dead stall */
    if (r < 0.25) return rand(180, 380); /* hesitation */
    return rand(35, 140); /* burst typing */
  };

  /* rep 1: clean, ends "."
     rep 2: deletes "slut" once, retypes it, ends "!!!"
     rep 3: the finale — BIG SLUT in caps, then the page rips
            out and the cycle starts over.
     compact (mobile) changes HOW the line overflows, not the
     script — punctuation stays. */
  const compact = window.matchMedia('(max-width: 749px)').matches;
  const SCRIPT = [
    { ending: '.', doubt: false, caps: false },
    { ending: '!!!', doubt: true, caps: false },
    { ending: '', doubt: false, caps: true },
  ];

  document.querySelectorAll('.it-typewriter').forEach((el) => {
    const textEl = el.querySelector('.it-typewriter__text');
    if (!textEl || el.dataset.itTypewriterRunning) return;
    el.dataset.itTypewriterRunning = 'true';

    const phrases = (textEl.dataset.itText || '')
      .split('|')
      .map((s) => s.trim())
      .filter(Boolean);
    if (phrases.length === 0) return;

    if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
      textEl.textContent = phrases[0];
      return;
    }

    let step = 0;
    let doubted = false;
    let buf = '';
    let queue = '';
    let deleting = 0;
    let pinkStart = -1; /* where the guiltily-retyped word begins */

    /* cross-page continuity: the typing state is stashed in
       sessionStorage every tick and restored on the next page,
       so navigating doesn't reboot the sentence — it flows on
       from where it left off (per browser tab). */
    const ST_KEY = 'itTypewriter:v1';
    const persist = () => {
      try {
        sessionStorage.setItem(
          ST_KEY,
          JSON.stringify({ step, doubted, buf, queue, deleting, pinkStart })
        );
      } catch (e) {}
    };

    /* render buf, wrapping the retyped word in the pink span */
    const render = () => {
      if (pinkStart >= 0 && buf.length > pinkStart) {
        textEl.textContent = '';
        textEl.append(buf.slice(0, pinkStart));
        const hot = document.createElement('span');
        hot.className = 'it-typewriter__doubt';
        hot.textContent = buf.slice(pinkStart, pinkStart + 7); /* slut!!! */
        textEl.append(hot);
        textEl.append(buf.slice(pinkStart + 7));
      } else {
        textEl.textContent = buf;
      }
    };

    const startStep = (withSpace) => {
      const spec = SCRIPT[step % SCRIPT.length];
      let base = phrases[step % phrases.length].replace(/[.!?]+$/, '');
      if (spec.caps) {
        base = base.replace(/big slut/i, 'BIG SLUT');
      }
      queue = (withSpace ? ' ' : '') + base + spec.ending;
      doubted = false;
    };

    const tick = () => {
      persist();
      /* backspacing the doubted word */
      if (deleting > 0) {
        buf = buf.slice(0, -1);
        deleting -= 1;
        render();
        /* after the last backspace: a long guilty beat before
           committing to the word again — and the word comes
           back in pink */
        if (deleting === 0 && doubted) pinkStart = buf.length;
        setTimeout(tick, deleting === 0 ? rand(1300, 2100) : rand(50, 130));
        return;
      }

      /* finished a repetition cleanly */
      if (queue.length === 0) {
        if (step % SCRIPT.length === SCRIPT.length - 1) {
          /* that was the BIG SLUT finale: hold on it, rip the
             page out, start the cycle over */
          setTimeout(() => {
            buf = '';
            pinkStart = -1;
            textEl.textContent = '';
            step = 0;
            startStep(false);
            setTimeout(tick, rand(500, 900));
          }, rand(2200, 3200));
          return;
        }
        step += 1;
        startStep(true);
        setTimeout(tick, rand(700, 1500));
        return;
      }

      const ch = queue[0];
      buf += ch;
      queue = queue.slice(1);
      render();

      /* hit the right margin (both modes are single-line now) —
         desktop: cut, hold, restart the cycle; mobile: refresh
         the line and CONTINUE the sentence where it left off.
         The lane is the strip's CONTENT box: clientWidth minus
         the paddings that pin the lane's ends to the icons. */
      const elCS = getComputedStyle(el);
      const laneW =
        el.clientWidth - parseFloat(elCS.paddingLeft) - parseFloat(elCS.paddingRight);
      /* rect width, NOT scrollWidth — the span is inline now and
         inline elements report scrollWidth as 0 (no rip, ever) */
      const overflowed = textEl.getBoundingClientRect().width > laneW;
      if (overflowed) {
        if (compact) {
          /* the line is full: pull the WHOLE partial word back
             (never split "and" into "an"/"d"), refresh the line,
             and the sentence continues with that word intact */
          let cut = buf.lastIndexOf(' ');
          if (cut < 0) cut = buf.length - 1;
          const partial = buf.slice(cut + 1);
          buf = buf.slice(0, cut);
          render();
          queue = partial + queue;
          setTimeout(() => {
            buf = '';
            pinkStart = -1;
            textEl.textContent = '';
            setTimeout(tick, rand(400, 800));
          }, rand(900, 1500));
          return;
        }
        setTimeout(() => {
          buf = '';
          pinkStart = -1;
          textEl.textContent = '';
          step = 0;
          startStep(false);
          setTimeout(tick, rand(500, 900));
        }, rand(1200, 2000));
        return;
      }

      /* rep 2's scripted crisis: just typed "slut" — freeze,
         delete it, sit with it, type it back anyway */
      if (
        SCRIPT[step % SCRIPT.length].doubt &&
        !doubted &&
        /(^|\s)slut$/.test(buf)
      ) {
        doubted = true;
        deleting = 4;
        queue = 'slut' + queue;
        setTimeout(tick, rand(500, 1100));
        return;
      }

      setTimeout(tick, delay());
    };

    /* resume from the previous page if we have saved state,
       otherwise start the cycle fresh */
    let resumed = false;
    try {
      const saved = JSON.parse(sessionStorage.getItem(ST_KEY));
      if (saved && typeof saved.buf === 'string') {
        step = saved.step | 0;
        doubted = !!saved.doubted;
        buf = saved.buf;
        queue = saved.queue || '';
        deleting = saved.deleting | 0;
        pinkStart = saved.pinkStart == null ? -1 : saved.pinkStart;
        render();
        resumed = true;
      }
    } catch (e) {}
    if (!resumed) startStep(false);
    setTimeout(tick, resumed ? rand(150, 400) : rand(400, 900));
  });

  /* The lane ends just before the right icon cluster at ANY
     window size (mobile: the profile icon; desktop: whichever
     icon is leftmost). Measured live and on every resize. */
  const sizeLane = () => {
    const strip = document.querySelector('.it-header-marquee');
    if (!strip) return;
    const acts = [
      ...document.querySelectorAll(
        '#header-component .header-actions__action, #header-component search-button'
      ),
    ]
      .map((e) => e.getBoundingClientRect())
      .filter((b) => b.width > 0);
    if (!acts.length) return;
    const leftmost = Math.min(...acts.map((b) => b.x));
    strip.style.paddingRight = Math.max(12, Math.round(window.innerWidth - leftmost + 8)) + 'px';
  };
  sizeLane();
  window.addEventListener('resize', sizeLane);

})();
